import { render } from "./order.vue?vue&type=template&id=16f2acb4"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"

import "./order.vue?vue&type=style&index=0&id=16f2acb4&lang=css"
script.render = render

export default script